import { render, staticRenderFns } from "./actor-desire-form.vue?vue&type=template&id=6d2abcab&scoped=true&"
import script from "./actor-desire-form.vue?vue&type=script&lang=ts&"
export * from "./actor-desire-form.vue?vue&type=script&lang=ts&"
import style0 from "./actor-desire-form.vue?vue&type=style&index=0&id=6d2abcab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2abcab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
